import React from 'react';

const initialState = {
    user: null
};

export const UserContext = React.createContext(initialState);
